import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../../graphql/common.datatypes';
import {Communication} from '../../../graphql/comms.datatypes';

interface CommsData {
    communications: {
        data: Communication[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_COMMS_QUERY = gql`
    query getComms($count: Int!, $page: Int!, $where: WhereConditions, $orderBy: [OrderByClause!]){
        communications(first: $count, page: $page, where: $where, orderBy: $orderBy){
            data {
              id
              ident
              communication_type
              title
              body
              active
              receiver
              log_code
              mandatory
            }
            ${gqlPaginatorInfo}
        }
    }
`;

export const getComms = (count: number, page: number, where?: any, orderBy?: any) => useQuery<CommsData>(
  GET_COMMS_QUERY,
  {
    variables: {
      count,
      page,
      where,
      orderBy,
    },
  }
);

export default getComms;
